// components/YandexMetrika.tsx

'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import ym, { YMInitializer } from 'react-yandex-metrika';

const YM_COUNTER_ID = 103521997;

const YandexMetrika = () => {
  const pathname = usePathname();

  useEffect(() => {
    const sendHit = () => {
      if (typeof ym === 'function') {
        const url = window.location.href;
        const referer = document.referrer || undefined;
        ym('hit', url, { referer });
      } else {
        setTimeout(sendHit, 100);
      }
    };

    sendHit(); // первый hit c полным URL
  }, []); // один раз при монтировании

  useEffect(() => {
    const sendHit = () => {
      if (typeof ym === 'function') {
        const url = window.location.href;
        const referer = document.referrer || undefined;
        ym('hit', url, { referer });
      } else {
        setTimeout(sendHit, 100);
      }
    };

    if (pathname) sendHit(); // hit на клиентскую навигацию
  }, [pathname]);

  return (
    // ym(103521997, 'init', {ssr:true, webvisor:true, clickmap:true, ecommerce:"dataLayer", accurateTrackBounce:true, trackLinks:true});
    <YMInitializer
      accounts={[YM_COUNTER_ID]}
      options={{
        defer: true,
        webvisor: true,
        clickmap: true,
        trackLinks: true,
        ssr: true,
        ecommerce: 'dataLayer',
        accurateTrackBounce: true,
      }}
      version="2"
    />
  );
};

export default YandexMetrika;
